import styled from "styled-components";

export const StyledZoomControl = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 2;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const zoomButtonBase = `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 22px;
  margin: 0;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  color: #2d2d2d;
  cursor: pointer;
  transition: background-color 120ms ease, opacity 120ms ease;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
`;

export const StyledZoomButton = styled.button`
  ${zoomButtonBase}
  width: 22px;
  padding: 0;
  background: rgba(255, 255, 255, 0.4);
`;

export const StyledZoomPercentage = styled.button`
  ${zoomButtonBase}
  width: 46px;
  min-width: 46px;
  padding: 0;
  background: #ffffff;
  color: #2e3538;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  font-variant-numeric: tabular-nums;
`;
